import React from 'react'

export default function LoadingSpinner() {
  return (
    <div className='spinner-container'>
      <div className={`loading-spinner  ${process.env.REACT_APP_MODE}-spinner`}></div>
    </div>
  )
}
